<!-- services page section  -->
<div class="sevices-herobanner">
  <div class="container">
    <div class="row service-banner-container">
      <div class="col-md-7 order-mobile-2">
        <h5 class="banner-title">
          <span class="text-nowrap">Custom Software Applications &</span> <br>
          Platforms to meet your specific needs
        </h5>
        <h6 class="banner-subtitle">
          We can guarantee that our service will be cheaper and faster than a "Buy and Customize" option…
        </h6>
      </div>
      <div class="col-md-5 order-mobile-1 text-center">
        <img src="./assets/images/services/sw-team.png" alt="" class="banner-img">
      </div>
    </div>
  </div>
</div>

<!-- API testing  -->
<div class="service-odd" id="apitesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">Payment Service Provider and Payment Gateway (PaymenTech)</h6>
        <p class="service-description">
          We have built a custom Payment Service Provider Application that processes Credit Cards, Debit Cards, Gift Cards, and ACH payments for online merchants. The app connects to multiple Payment Gateways and implements dynamic smart routing. It also provides an API interface that makes integration with shopping carts simple and easy.
        </p>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/payment-gateway.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>

<!-- Mobile app testing  -->
<div class="service-even" id="mobiletesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">Platform for Insurance Agencies/Brokers to manage Individuals and Groups (InsurTech)</h6>
        <p class="service-description">
          We have built an InsurTech platform capable of using AI/ML to manage and recommend insurance products based on customer needs and history. It matches customers with best-in-class carriers and providers using location and product category.
        </p>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/insurance-tech.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>

<!-- Browser testing  -->
<div class="service-odd" id="browsertesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/felowship-logo.svg" alt="" class="service-img">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">Healthcare Sharing Platform (Healthcare IT)</h6>
        <p class="service-description">
          We have built a Healthcare Sharing Platform that guides the Medical Cost Sharing Community to share their medical expenses. The members give and receive financial support from each other for their medical needs. The platform provides best-in-class service to our members through charitable donations and medical expense sharing via a proprietary ShareBox.
        </p>
      </div>
    </div>
  </div>
</div>
